import React from "react";
import { Row } from "react-bootstrap";
import styles from "./AsnPage.module.css";
import "moment/locale/id";
import SearchPurchaseOrder from "./components/SearchPurchaseOrder";
import ExamplePurchaseOrder from "./components/ExamplePurchaseOrder";
import DetailPurchaseOrder from "./components/DetailPurchaseOrder";

const AsnSearchForm = ({
  isLoading,
  setIsLoading,
  setPurchaseOrder,
  purchaseOrder,
  displayAlert,
}) => {
  return (
    <section className="search-form">
      <Row className={styles.confirmationCard}>
        <SearchPurchaseOrder
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setPurchaseOrder={setPurchaseOrder}
          displayAlert={displayAlert}
        />
        <ExamplePurchaseOrder visible={!purchaseOrder} />
        <DetailPurchaseOrder
          visible={!!purchaseOrder}
          purchaseOrder={purchaseOrder}
        />
      </Row>
    </section>
  );
};

export default AsnSearchForm;
